import { DEFAULT_QUERY_CLIENT_CONFIG, enhanceMutationDefaults, enhanceQueryDefaults } from "./getDefaultOptions";

import type { QueryClientConfig } from "@tanstack/react-query";
import type { QueryDefaults, MutationDefaults, QueryDefaultsConfig, MutationDefaultsConfig } from "./types";

export const getQueryClientConfig = (config?: QueryClientConfig): QueryClientConfig => {
    const defaultQueries = {
        ...DEFAULT_QUERY_CLIENT_CONFIG.defaultOptions?.queries,
        ...config?.defaultOptions?.queries,
    } as QueryDefaultsConfig;

    const defaultMutations = {
        ...DEFAULT_QUERY_CLIENT_CONFIG.defaultOptions?.mutations,
        ...config?.defaultOptions?.mutations,
    } as MutationDefaultsConfig;

    const enhancedQueries = enhanceQueryDefaults(defaultQueries) as QueryDefaults;
    const enhancedMutations = enhanceMutationDefaults(defaultMutations) as MutationDefaults;

    return {
        ...DEFAULT_QUERY_CLIENT_CONFIG,
        ...config,
        defaultOptions: {
            ...DEFAULT_QUERY_CLIENT_CONFIG.defaultOptions,
            ...config?.defaultOptions,
            queries: enhancedQueries,
            mutations: enhancedMutations,
        },
    };
};
